import React from 'react'
import { Icon, IconButton } from '@material-ui/core'
import * as Actions from 'app/store/actions'
import { useDispatch } from 'react-redux'
import clsx from 'clsx'
import { makeStyles } from '@material-ui/styles'
const useStyles = makeStyles((theme) => ({
  icon: {
    color: theme.palette.primary.contrastText,
  },
}))

const defaultProps = {
  children: <Icon>menu</Icon>,
}

function NavbarMobileToggleButton(props) {
  const dispatch = useDispatch()
  const classes = useStyles()

  const { children = defaultProps.children } = props

  return (
    <IconButton
      className={clsx(props.className, classes.icon)}
      onClick={() => dispatch(Actions.navbarToggleMobile())}
      disableRipple
    >
      {children}
    </IconButton>
  )
}

export default NavbarMobileToggleButton
